import baseAPI from '@/api/baseAPI'

class TeachersAPI extends baseAPI {
  get entity() {
    return {
      route: `/teachers`,
      name: 'أستاذ'
    }
  }

  assign(data){
    return new Promise((resolve, reject) => {
      this.request.post(`${this.entity.route}/assign`, data)
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }
}

export default new TeachersAPI()
